import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import SectionTitle from './SectionTitle';
import CustomLightButton from '../../../../../components/CustomLightButton';
import PaginationWrapper from '../../../../../components/PaginationWrapper';
import DeletableChip from '../../../../../components/DeletableChip';

class PromoCodeCombineRestrictionConfigSection extends Component {
    normalize = (s) => (s ?? '').toString().toLowerCase().trim();

    findIndexById = (id) => {
        const { selectedCodes } = this.props;
        const myCodes = Array.isArray(selectedCodes) ? [...selectedCodes] : [];
        return myCodes.findIndex((c) => this.normalize(c?.id) === this.normalize(id));
    };

    deleteById = (id) => {
        const { selectedCodes, setSelectedCodes, editMode } = this.props;
        const myCodes = Array.isArray(selectedCodes) ? [...selectedCodes] : [];
        const index = this.findIndexById(id);

        if (index >= 0 && index < myCodes.length) {
            if (!editMode) {
                myCodes.splice(index, 1);
            } else {
                myCodes[index] = { ...myCodes[index], deleted: true };
            }
            setSelectedCodes?.(myCodes);
        }
    };

    reselectById = (id) => {
        const { selectedCodes, setSelectedCodes, editMode } = this.props;
        const myCodes = Array.isArray(selectedCodes) ? [...selectedCodes] : [];
        const index = this.findIndexById(id);

        if (index >= 0 && index < myCodes.length) {
            if (editMode) {
                const { deleted, ...rest } = myCodes[index];
                myCodes[index] = rest;
                setSelectedCodes?.(myCodes);
            }
        }
    };

    render() {
        const { selectedCodes = [], onSelectionPressed } = this.props;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/voucher.png')}
                    label="Kombinationsbeschränkung"
                />

                {(selectedCodes?.length ?? 0) > 0 && (
                    <PaginationWrapper
                        items={selectedCodes ?? []}
                        pageSize={5}
                        threshold={5}
                        disablePaginationOnSearch={true}
                        showSearch={selectedCodes?.length > 5}
                        filterFn={(code, term) => {
                            const name = this.normalize(code?.name);
                            const codeStr = this.normalize(code?.code);
                            const id = this.normalize(code?.id);
                            const shop = this.normalize(code?.shopInfo?.name);
                            return (
                                name.includes(term) ||
                                codeStr.includes(term) ||
                                id.includes(term) ||
                                shop.includes(term)
                            );
                        }}
                    >
                        {(pagedItems) => (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {pagedItems.map((item) => {
                                    const textColor = item.deleted ? '#979797' : '#424242';
                                    const textDecoration = item.deleted ? 'line-through' : 'none';

                                    return (
                                        <DeletableChip
                                            key={`PROMO_${item.id}`}
                                            onDelete={() => {
                                                this.deleteById(item.id);
                                            }}
                                            hideDelete={item.deleted}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 0.75,
                                                    py: 0.75,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: textColor,
                                                        fontWeight: 'bold',
                                                        textDecoration,
                                                        fontSize: 14,
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    Code: {item.code ?? item.name} ({item.id})
                                                </Typography>

                                                {item.shopInfo && (
                                                    <Typography
                                                        sx={{
                                                            color: textColor,
                                                            textDecoration,
                                                            fontSize: 14,
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        Shop: {item.shopInfo?.name}, {item.shopInfo?.street}{' '}
                                                        {item.shopInfo?.houseNumber}, {item.shopInfo?.zip}{' '}
                                                        {item.shopInfo?.city}
                                                    </Typography>
                                                )}

                                                {item.deleted && (
                                                    <Box
                                                        onClick={() => this.reselectById(item.id)}
                                                        sx={{
                                                            backgroundColor: '#dffbdf',
                                                            mt: 0.75,
                                                            borderRadius: '6px',
                                                            p: 1,
                                                            cursor: 'pointer',
                                                            alignSelf: 'flex-start',
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: '#4d714d',
                                                                textAlign: 'center',
                                                                fontSize: 14,
                                                            }}
                                                        >
                                                            Wiederherstellen
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </DeletableChip>
                                    );
                                })}
                            </Box>
                        )}
                    </PaginationWrapper>
                )}

                <CustomLightButton
                    icon={require('../../../../../assets/icons/voucher.png')}
                    label="Promo-Code hinzufügen"
                    onPress={() => onSelectionPressed?.()}
                />
            </Box>
        );
    }
}

export default PromoCodeCombineRestrictionConfigSection;